import type { Validation } from "@/lib/validation"
import { buildArrayValidator } from "@/lib/validation/array/buildValidator"
import { buildCollectionValidator } from "@/lib/validation/collection/buildValidator"
import { buildItemValidator } from "@/lib/validation/item/buildValidator"
import { buildMirrorValidator } from "@/lib/validation/mirror/buildValidator"

export const buildValidators = <
  Registry extends Validation.BaseRegistry,
  Element
>({
  api,
  expectation,
}: {
  api: Validation.API<Registry>
  expectation: Validation.Expectation<Registry, Element>
}): Validation.Validators<Element> => {
  return {
    array: buildArrayValidator({
      api,
      expectation,
    }),
    collection: buildCollectionValidator({
      api,
      expectation,
    }),
    item: buildItemValidator({
      api,
      expectation,
    }),
    mirror: buildMirrorValidator({
      api,
      expectation,
    }),
  }
}
